import { reactive } from 'vue';

export const inquiryNavigationSource = reactive({
  value: 'menu',
});
